var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_1110_844)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M30.4875 1.73864V30.8595H1.36663V1.73864H30.4875ZM24.9112 2.97783H29.2483V7.315H24.9112V2.97783ZM19.3348 2.97783H23.672V7.315H19.3348V2.97783ZM18.0957 2.97783H13.7585V7.315H18.0957V2.97783ZM12.5193 2.97783H8.18221L8.18221 7.315H12.5193V2.97783ZM6.94302 2.97783H2.60581V7.315H6.94302V2.97783ZM2.60581 8.55419V12.8913H6.94302V8.55419H2.60581ZM2.60581 14.1305V18.4677H6.94302V14.1305H2.60581ZM2.60581 19.7069V24.044H6.94302V19.7069H2.60581ZM2.60581 25.2832V29.6204H6.94302V25.2832H2.60581ZM8.18221 29.6204H12.5193V25.2832H8.18221V29.6204ZM13.7585 29.6204H18.0957V25.2832H13.7585V29.6204ZM19.3348 29.6204H23.672V25.2832H19.3348V29.6204ZM24.9112 29.6204H29.2483V25.2832H24.9112V29.6204ZM29.2483 24.044V19.7069H24.9112V24.044H29.2483ZM29.2483 18.4677V14.1305H24.9112V18.4677H29.2483ZM29.2483 12.8913V8.55419H24.9112V12.8913H29.2483ZM23.672 19.7069V24.044H19.3348V19.7069H23.672ZM18.0957 19.7069V24.044H13.7585V19.7069H18.0957ZM12.5193 19.7069V24.044H8.18221V19.7069H12.5193ZM8.18221 18.4677H12.5193V14.1305H8.18221V18.4677ZM13.7585 18.4677H18.0957V14.1305H13.7585V18.4677ZM19.3348 18.4677H23.672V14.1305H19.3348V18.4677ZM23.672 8.55419V12.8913H19.3348V8.55419H23.672ZM18.0957 8.55419V12.8913H13.7585V8.55419H18.0957ZM12.5193 8.55419V12.8913H8.18221V8.55419H12.5193Z",
            fill: "#D0D0D0"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M31.4279 1.10748L19.187 25.6138L8.1838 15.9131L2.92788 32L0.572052 31.2303L6.99766 11.5634L18.4094 21.6242L29.2108 0L31.4279 1.10748Z",
            fill: "#179E7E"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_1110_844" } }, [
          _c("rect", { attrs: { width: "32", height: "32", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }